/* eslint-disable react-hooks/exhaustive-deps */
import { Progress, Form, BackTop } from 'antd';
import classNames from 'classnames';
import { Fragment, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import StepWizard from 'react-step-wizard';
import IconBack from '../../../assets/Images/icons/icon-back';
import ModalDiscardChanges from '../../../components/Shared/modal/discardChanges';
import { ROUTER } from '../../../constants/router';
import useNotify from '../../../context/Notification/useNotify';
import DCDPOService from '../../../services/DCDPO.service';
import { useBlocker } from '../../../util/usePrompt';

import Step1 from './components/Step1';
import Step2 from './components/Step2';
import Step3 from './components/Step3';
import Step4 from './components/Step4';
import Step5 from './components/Step5';
import Step6 from './components/Step6';
import Step7 from './components/Step7';
import Step8 from './components/Step8';
import StepList from './components/StepList';
import StepPreview from './components/StepPreview';
import GlobalService from '../../../services/Global.service';
import moment from 'moment';
import { POLICY_NAME } from '../POLICY';
import CCTVPolicyService from '../../../services/CCTVPolicy.service';
import { INIT } from './components/init';
import { convertToISODateTime } from '../../../util/util';

const { Provider } = Form;

const CCTVDetail = () => {
    const { t } = useTranslation(['translation', POLICY_NAME.CCTV_POLICY]);
    let navigate = useNavigate();
    const location = useLocation();
    const { id } = useParams();
    const notify = useNotify();

    const [state, updateState] = useState();

    const [currentSelectList, setCurrentSelectList] = useState(1);

    const [loading, setLoading] = useState(false);
    const [loading_, setLoadingSave] = useState(false);
    const [loadingSaveDraft, setLoadingSaveDraft] = useState(false);
    const [fixed, setFixed] = useState(false);
    const [editMode] = useState(false);

    // form
    const [cctvPolicy] = Form.useForm();
    const [cctvIntroductionLawfulBasis] = Form.useForm();
    const [cctvPersonalDataCollect] = Form.useForm();
    const [cctvReasonCollectedData] = Form.useForm();
    const [cctvTransferPersonalData] = Form.useForm();
    const [cctvRetainPersonalData] = Form.useForm();
    const [cctvDataSubjectRight] = Form.useForm();
    const [cctvPolicyChange] = Form.useForm();

    const [previewData, setPreviewData] = useState(INIT);

    const [change, setChange] = useState(false);
    const [openChange, setOpenChange] = useState(false);
    const [nextLocation, setNextLocation] = useState(null);
    const [isChangeLocation, setIsChangeLocation] = useState(false);
    const [dsType, setDsType] = useState([]);

    // check validations

    const [step1, setStep1] = useState(false);
    const [step2, setStep2] = useState(false);
    const [step3, setStep3] = useState(false);
    const [step4, setStep4] = useState(false);
    const [step5, setStep5] = useState(false);
    const [step6, setStep6] = useState(false);
    const [step7, setStep7] = useState(false);
    const [step8, setStep8] = useState(false);

    useBlocker((nextLocation) => onChangePage(nextLocation), change);

    const onChangePage = (nextLocation) => {
        setOpenChange(true);
        setIsChangeLocation(true);
        setNextLocation(nextLocation);
    };

    const handelOk = () => {
        setOpenChange(false);
        setChange(false);
    };

    const handelOkLocation = async () => {
        await setOpenChange(false);
        await setChange(false);
        await setIsChangeLocation(false);
        await navigate(
            nextLocation.location.pathname + nextLocation.location.search
        );
    };

    useEffect(() => {
        const current = location.hash.replace('#step', '');
        if (current) {
            setCurrentSelectList(Number(current));
        }
        if (current === '8') {
            setFixed(false);
        }
    }, [location]);

    const setInstance = (SW) => {
        updateState({
            ...state,
            SW,
        });
    };

    const genaratePayload = async (name, isPublish) => {
        if (!isPublish) setLoadingSaveDraft(true);
        else setLoadingSave(true);

        setOpenChange(false);
        setChange(false);

        let values = {
            cctvPolicy: cctvPolicy.getFieldsValue(),
            cctvIntroductionLawfulBasis:
                cctvIntroductionLawfulBasis.getFieldsValue(),
            cctvPersonalDataCollect: cctvPersonalDataCollect.getFieldsValue(),
            cctvReasonCollectedData: cctvReasonCollectedData.getFieldsValue(),
            cctvTransferPersonalData: cctvTransferPersonalData.getFieldsValue(),
            cctvRetainPersonalData: cctvRetainPersonalData.getFieldsValue(),
            cctvDataSubjectRight: cctvDataSubjectRight.getFieldsValue(),
            cctvPolicyChange: cctvPolicyChange.getFieldsValue(),
        };

        let cctvPolicyDataSubjectType = [];

        const dsTypeGroup = values.cctvPolicy.cctvPolicyDataSubjectType;

        if (dsTypeGroup) {
            const dsTypefilter = dsType.filter((ds) =>
                dsTypeGroup.includes(ds.id)
            );
            cctvPolicyDataSubjectType = dsTypefilter.map((ds) => {
                return {
                    cctvDataSubjectId: ds.id,
                    cctvDataSubjectNameTh: ds.nameTh,
                    cctvDataSubjectNameEn: ds.nameEn,
                };
            });
        }

        const cctvEffectiveDate = values.cctvPolicy?.cctvEffectiveDate
            ? moment(values.cctvPolicy?.cctvEffectiveDate).valueOf()
            : null;

        let payload = {
            ...values,
            cctvPolicy: {
                ...values.cctvPolicy,
                cctvPolicyDataSubjectType,
                cctvEffectiveDate,
                isPublish,
            },
        };

        try {
            const { data } = await CCTVPolicyService.saveCCTV(payload);
            if (data.resultCode === 1) {
                notify({
                    title: t('common.Success'),
                    description: t('Successfully saved data'),
                });
                if (name === 'preview') {
                    navigate(
                        `${ROUTER.POLICY.DEFAULT}?tab=${POLICY_NAME.CCTV_POLICY}`
                    );
                }
                if (!isPublish) {
                    const cctvPolicyId = data?.resultData?.cctvPolicyId;
                    const hash = window.location.hash;
                    navigate(
                        ROUTER?.POLICY?.CCTV_PRIVACY + `/${cctvPolicyId}${hash}`
                    );
                    getCCTVPolicy(cctvPolicyId);
                }
                setLoadingSave(false);
                setLoadingSaveDraft(false);
            }
        } catch (error) {
            notify({
                type: 'error',
                title: t('common.Fail'),
                description: t('Failed to submitted'),
            });
            setLoadingSave(false);
            setLoadingSaveDraft(false);
            console.log(error);
        }
    };

    const saveDraft = () => {
        genaratePayload(null, false);
    };

    const onFormFinish = (name, _) => {
        genaratePayload(name, true);
    };

    const getCCTVPolicy = async (id) => {
        try {
            setLoading(true);
            const { data } = await CCTVPolicyService.getCCTVDetail(id);
            if (data.resultData) {
                const data_ = data?.resultData;
                const effDate = convertToISODateTime(
                    data_?.cctvPolicy.effectiveDate
                );
                const cctvPolicyDataSubjectType =
                    data_.cctvPolicy.cctvPolicyDataSubjectType.map(
                        (ds) => ds.cctvDataSubjectId
                    );
                const cctvEffectiveDate = data_.cctvPolicy.effectiveDate
                    ? moment(effDate)
                    : moment();

                cctvPolicy.setFieldsValue({
                    ...data_?.cctvPolicy,
                    cctvPolicyDataSubjectType,
                    cctvEffectiveDate,
                });
                cctvIntroductionLawfulBasis.setFieldsValue(
                    data_?.cctvIntroductionLawfulBasis
                );
                cctvPersonalDataCollect.setFieldsValue(
                    data_?.cctvPersonalDataCollect
                );
                cctvReasonCollectedData.setFieldsValue(
                    data_?.cctvReasonCollectedData
                );
                cctvTransferPersonalData.setFieldsValue(
                    data_?.cctvTransferPersonalData
                );
                cctvRetainPersonalData.setFieldsValue(
                    data_?.cctvRetainPersonalData
                );
                cctvDataSubjectRight.setFieldsValue(
                    data_?.cctvDataSubjectRight
                );
                cctvPolicyChange.setFieldsValue(data_?.cctvPolicyChange);
                setPreviewData(data_);
                setLoading(false);
            }
        } catch (error) {
            console.log(error);
            setLoading(false);
        }
    };

    const getDsTypeDropdown = async () => {
        try {
            const { data } = await GlobalService.getDs();
            if (data?.resultData) {
                setDsType(data?.resultData?.dataSubjectType);
            }
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        setLoading(true);
        if (id !== 'new') getCCTVPolicy(id);
        else getDCDPO();
        getDsTypeDropdown();
    }, [id]);

    const onFormChange = (name, info) => {
        if (info.changedFields.length > 0) {
            setChange(true);
        }
    };

    const getDCDPO = async () => {
        try {
            const { data } = await DCDPOService.getDCDPO();
            const item = data?.resultData;
            if (item) {
                cctvPolicyChange.setFieldsValue({
                    cctvDataControllerContentTh: item?.staffNameDPOTh,
                    cctvDataControllerContentEn: item?.staffNameDPOEn,
                    cctvDataProtectionContentTh: `${item?.nameDPOTh}\n${item?.addressTh}`,
                    cctvDataProtectionContentEn: `${item?.nameDPOEn}\n${item?.addressEn}`,
                });
            }
        } catch (error) {
            console.log(error);
        }
    };

    const steps = [step1, step2, step3, step4, step5, step6, step7, step8];
    const stepPreview = steps.length + 1;
    const passStep = steps.every((step) => step === true);
    const filter = steps.filter(Boolean).length;
    const currentProgress = ((filter * 100) / steps.length).toFixed(0);
    const stepObject = steps.reduce((result, step, index) => {
        const stepName = `step${index + 1}`;
        return { ...result, [stepName]: step };
    }, {});

    return (
        <Fragment>
            <div className="title flex items-center">
                <div
                    className="cursor-pointer mr-3 space-x-2"
                    onClick={() => {
                        navigate(
                            `${ROUTER.POLICY.DEFAULT}?tab=${POLICY_NAME.CCTV_POLICY}`
                        );
                    }}
                >
                    <IconBack />
                    <span>
                        {id === 'new'
                            ? t('Add CCTV Policy', {
                                  ns: POLICY_NAME.CCTV_POLICY,
                              })
                            : t('Edit CCTV Policy', {
                                  ns: POLICY_NAME.CCTV_POLICY,
                              })}
                    </span>
                </div>
            </div>
            <div className="sub-title">
                <span className="text-sm text-gray-400">
                    {t('Policy')} /{' '}
                    {t('CCTV Policy', {
                        ns: POLICY_NAME.CCTV_POLICY,
                    })}{' '}
                    /{' '}
                </span>
                <span>
                    {id === 'new'
                        ? t('Add CCTV Policy', {
                              ns: POLICY_NAME.CCTV_POLICY,
                          })
                        : t('Edit CCTV Policy', {
                              ns: POLICY_NAME.CCTV_POLICY,
                          })}
                </span>
            </div>
            <div className="mt-4 grid grid-cols-4 gap-4">
                {currentSelectList !== stepPreview && (
                    <StepList
                        steps={stepObject}
                        setCurrentSelectList={() => {
                            // cannot move sp5
                        }}
                        SW={state?.SW}
                        currentSelectList={currentSelectList}
                        setFixed={setFixed}
                    />
                )}
                <div
                    className={classNames({
                        'col-span-3': currentSelectList !== stepPreview,
                        'col-span-4': currentSelectList === stepPreview,
                    })}
                >
                    {currentSelectList !== 9 && (
                        <div className="bg-white rounded-md p-4 flex font-semibold text-base">
                            <div className="flex-1 -mt-0.5">
                                <Progress
                                    strokeColor={{
                                        '0%': '#4ACE8F',
                                        '100%': '#4ACE8F',
                                    }}
                                    percent={currentProgress}
                                    status="active"
                                    showInfo={false}
                                />
                            </div>
                            <span
                                className={`pl-6 pr-2 ${
                                    currentProgress === 0
                                        ? 'text-red-500'
                                        : 'text-green-400'
                                }`}
                            >
                                {currentProgress}% {t('succeed')}
                            </span>

                            <span>{t('filledinformation')}</span>
                        </div>
                    )}
                    <Provider
                        onFormChange={onFormChange}
                        onFormFinish={onFormFinish}
                    >
                        <div className="mt-4 bg-white rounded-md p-4 overflow-hidden">
                            <StepWizard
                                isHashEnabled
                                instance={setInstance}
                                onStepChange={(e) => {
                                    setCurrentSelectList(e.activeStep);
                                }}
                            >
                                <Step1
                                    loadingSaveDraft={loadingSaveDraft}
                                    setStep1={setStep1}
                                    loading={loading_}
                                    editMode={editMode}
                                    form={cctvPolicy}
                                    previewData={previewData}
                                    dsType={dsType}
                                    saveDraft={saveDraft}
                                />
                                <Step2
                                    loadingSaveDraft={loadingSaveDraft}
                                    cctvPolicy={cctvPolicy.getFieldsValue()}
                                    setStep2={setStep2}
                                    previewData={previewData}
                                    loading={loading_}
                                    editMode={editMode}
                                    form={cctvIntroductionLawfulBasis}
                                    saveDraft={saveDraft}
                                />
                                <Step3
                                    loadingSaveDraft={loadingSaveDraft}
                                    cctvPolicy={cctvPolicy.getFieldsValue()}
                                    setStep3={setStep3}
                                    loading={loading_}
                                    editMode={editMode}
                                    form={cctvPersonalDataCollect}
                                    previewData={previewData}
                                    saveDraft={saveDraft}
                                />
                                <Step4
                                    loadingSaveDraft={loadingSaveDraft}
                                    cctvPolicy={cctvPolicy.getFieldsValue()}
                                    setStep4={setStep4}
                                    loading={loading_}
                                    editMode={editMode}
                                    form={cctvReasonCollectedData}
                                    previewData={previewData}
                                    saveDraft={saveDraft}
                                />
                                <Step5
                                    loadingSaveDraft={loadingSaveDraft}
                                    cctvPolicy={cctvPolicy.getFieldsValue()}
                                    setStep5={setStep5}
                                    loading={loading_}
                                    editMode={editMode}
                                    form={cctvTransferPersonalData}
                                    previewData={previewData}
                                    saveDraft={saveDraft}
                                />
                                <Step6
                                    loadingSaveDraft={loadingSaveDraft}
                                    cctvPolicy={cctvPolicy.getFieldsValue()}
                                    setStep6={setStep6}
                                    loading={loading_}
                                    editMode={editMode}
                                    form={cctvRetainPersonalData}
                                    previewData={previewData}
                                    saveDraft={saveDraft}
                                />
                                <Step7
                                    loadingSaveDraft={loadingSaveDraft}
                                    setStep7={setStep7}
                                    loading={loading_}
                                    editMode={editMode}
                                    form={cctvDataSubjectRight}
                                    previewData={previewData}
                                    saveDraft={saveDraft}
                                />
                                <Step8
                                    loadingSaveDraft={loadingSaveDraft}
                                    cctvPolicy={cctvPolicy.getFieldsValue()}
                                    setStep8={setStep8}
                                    loading={loading_}
                                    editMode={editMode}
                                    form={cctvPolicyChange}
                                    previewData={previewData}
                                    passStep={passStep}
                                    saveDraft={saveDraft}
                                />
                                <StepPreview
                                    loading_={loading_}
                                    loadingSaveDraft={loadingSaveDraft}
                                    loading={loading}
                                    previewData={previewData}
                                    forms={{
                                        cctvPolicy,
                                        cctvIntroductionLawfulBasis,
                                        cctvPersonalDataCollect,
                                        cctvReasonCollectedData,
                                        cctvTransferPersonalData,
                                        cctvRetainPersonalData,
                                        cctvDataSubjectRight,
                                        cctvPolicyChange,
                                    }}
                                    privacyNoticeId={id}
                                    saveDraft={saveDraft}
                                    dsType={dsType}
                                />
                            </StepWizard>
                        </div>
                    </Provider>
                </div>
            </div>
            <ModalDiscardChanges
                open={openChange}
                handelOk={isChangeLocation ? handelOkLocation : handelOk}
                handelClose={() => setOpenChange(false)}
            />
            <BackTop>
                <div className="flex items-center justify-center" style={style}>
                    <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M8.76395 15.232L8.76395 3.47773L14.8711 10.513C14.9695 10.6255 15.1523 10.5572 15.1523 10.4085L15.1523 8.63064C15.1523 8.55229 15.1242 8.47796 15.074 8.4197L8.48672 0.827956C8.42645 0.758424 8.35193 0.70266 8.26823 0.664442C8.18452 0.626224 8.09358 0.606445 8.00156 0.606445C7.90954 0.606445 7.8186 0.626224 7.7349 0.664442C7.65119 0.70266 7.57668 0.758424 7.51641 0.827956L0.888949 8.46389C0.862833 8.49403 0.848771 8.53019 0.848771 8.56836L0.848771 10.4065C0.848771 10.5552 1.03359 10.6235 1.13002 10.511L7.23716 3.47773L7.23716 15.232C7.23716 15.3204 7.30949 15.3927 7.39788 15.3927L8.60324 15.3927C8.69163 15.3927 8.76395 15.3204 8.76395 15.232Z"
                            fill="white"
                        />
                    </svg>
                </div>
            </BackTop>
        </Fragment>
    );
};

const style = {
    height: 40,
    width: 40,
    lineHeight: '40px',
    borderRadius: 4,
    backgroundColor: '#7B67FB',
    color: '#fff',
    textAlign: 'center',
    fontSize: 14,
};

export default CCTVDetail;
